import { dictionary, type DictionaryKey } from './dictionary';
import type { Lang, Vars } from './types';

/** Fills {name} placeholders. Anything not supplied is left alone, never blanked. */
export function interpolate(template: string, vars?: Vars): string {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (whole, name: string) =>
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : whole,
  );
}

/**
 * Look up a key in one language. Pure, so it works in a service worker, in a
 * test, and on the server as well as in a component.
 */
export function t(key: DictionaryKey, lang: Lang, vars?: Vars): string {
  const entry = dictionary[key];
  if (!entry) {
    // Should be unreachable: DictionaryKey is a literal union.
    return key;
  }
  return interpolate(entry[lang], vars);
}

/** Both languages at once, for a Mensajes bubble that can reveal the original. */
export function tBoth(key: DictionaryKey, vars?: Vars): { es: string; en: string } {
  return { es: t(key, 'es', vars), en: t(key, 'en', vars) };
}
